import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.primary.dark,
      fontWeight: "bold",
    },
  },
}))

const GuideOutline = ({ steps }) => {
  const classes = useStyles()
  let pathName = ""

  if (typeof window !== `undefined`) {
    pathName = window.location.pathname
  }

  return (
    <ol>
      {steps.map(step => (
        <Link
          key={step.name}
          to={`${pathName}${step.path}`}
          className={classes.link}
        >
          <li>{step.name}</li>
        </Link>
      ))}
    </ol>
  )
}

GuideOutline.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
}

export default GuideOutline
